<div class="color-area-component">
  <div #wrapperDrag class="wrapperDrag">
    <canvas #canvas class="color-area" width="265" height="135" (click)="mouseClick($event)"></canvas>
    <div (cdkDragMoved)="dragMoved($event)" #indicator class="color-indicator" cdkDragBoundary=".wrapperDrag" cdkDrag></div>
  </div>
</div>
